.sk {
  display: block;
  border-radius: 8px;
  background: linear-gradient(90deg, var(--color-neutral-soft) 25%, var(--color-border) 50%, var(--color-neutral-soft) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s linear infinite;
}
@keyframes shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
